import { JOIN_FLOW_STEPS, UPGRADE_STEPS } from '@/lib/constants/maverick';
export enum UPGRADE_ROUTES {
  UPGRADE = 'upgrade',
  OPTIONS = 'upgrade/options',
  UPCYCLE = 'upgrade/upcycle',
  ACCESSORIES = 'upgrade/accessories',
  ORDER = 'upgrade/order',
  RECEIPT = 'upgrade/receipt',
}
export enum JOIN_FLOW_ROUTES {
  JOIN = 'join',
  BANDS = 'bands',
  MEMBERSHIP = 'membership',
  ACCESSORIES = 'accessories',
  ORDER = 'order',
  RECEIPT = 'receipt',
  FAMILY = 'family',
}

/**
 * Non-hook version of getCurrentPageMaverick that takes a pathname parameter
 * instead of using the usePathname hook
 */
export const getCurrentPageMaverick = (pathname?: string): UPGRADE_STEPS | JOIN_FLOW_STEPS => {
  if (!pathname) {
    pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  }
  if (pathname.includes('/upgrade/accessories')) {
    return UPGRADE_STEPS.ACCESSORIES;
  } else if (pathname.includes('/upgrade/upcycle')) {
    return UPGRADE_STEPS.UPCYCLE;
  } else if (pathname.includes(`/upgrade/options`)) {
    return UPGRADE_STEPS.OPTIONS;
  } else if (pathname.includes('/upgrade/order')) {
    return UPGRADE_STEPS.ORDER;
  } else if (pathname.includes('/upgrade/receipt')) {
    return UPGRADE_STEPS.RECEIPT;
  } else if (pathname.includes('/upgrade/ineligible')) {
    return UPGRADE_STEPS.INELIGIBLE;
  } else if (pathname.includes('/upgrade/signin')) {
    return UPGRADE_STEPS.SIGNIN;
  } else if (pathname.includes('upgrade')) {
    return UPGRADE_STEPS.UPGRADE;
  } else if (pathname.includes('bands')) {
    return JOIN_FLOW_STEPS.BANDS;
  } else if (pathname.includes('membership')) {
    return JOIN_FLOW_STEPS.MEMBERSHIP;
  } else if (pathname.includes('accessories')) {
    return JOIN_FLOW_STEPS.ACCESSORIES;
  } else if (pathname.includes('order')) {
    return JOIN_FLOW_STEPS.ORDER;
  } else if (pathname.includes('receipt')) {
    return JOIN_FLOW_STEPS.RECEIPT;
  } else if (pathname.includes('family')) {
    return JOIN_FLOW_STEPS.FAMILY;
  }
  return JOIN_FLOW_STEPS.JOIN;
};